import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";
import { FEE_STATUS_META } from "./feeUtils";
import { FeeDetailFields } from "./FeeDetailFields";
import { FeeAttachments } from "./FeeAttachments";

export const FeeEditDialog = ({ editing, setEditing, onSave, saving, project = {}, onPreview }) => (
  <Dialog open={!!editing} onOpenChange={(o) => { if (!o) setEditing(null); }}>
    <DialogContent className="rounded-sm max-w-lg max-h-[90vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="font-heading">Edit fee</DialogTitle>
        <DialogDescription className="sr-only">Update this project fee&apos;s details.</DialogDescription>
      </DialogHeader>
      {editing && (
        <div className="space-y-3">
          <Input value={editing.label} onChange={(e) => setEditing({ ...editing, label: e.target.value })} placeholder="Label" className="rounded-sm" data-testid="fee-edit-label" />
          <Input type="number" min="0" step="0.01" value={editing.amount} onChange={(e) => setEditing({ ...editing, amount: e.target.value })} placeholder="Amount" className="rounded-sm" data-testid="fee-edit-amount" />
          <Select value={editing.status} onValueChange={(v) => setEditing({ ...editing, status: v })}>
            <SelectTrigger className="rounded-sm"><SelectValue /></SelectTrigger>
            <SelectContent>{Object.keys(FEE_STATUS_META).map((s) => <SelectItem key={s} value={s}>{FEE_STATUS_META[s].label}</SelectItem>)}</SelectContent>
          </Select>
          <Input type="date" value={editing.due_date} onChange={(e) => setEditing({ ...editing, due_date: e.target.value })} className="rounded-sm" />
          <Input value={editing.invoice_number || ""} onChange={(e) => setEditing({ ...editing, invoice_number: e.target.value })} placeholder="Invoice #" className="rounded-sm" data-testid="fee-edit-invoice" />
          <label className="flex items-center gap-2 text-sm text-zinc-600 cursor-pointer">
            <input type="checkbox" checked={!!editing.gst} onChange={(e) => setEditing({ ...editing, gst: e.target.checked })} className="h-4 w-4 rounded-sm accent-zinc-900" data-testid="fee-edit-gst" />
            Add 10% GST
          </label>
          {editing.status === "paid" && (
            <div>
              <label className="text-[11px] font-semibold uppercase tracking-wider text-zinc-500">Payment date</label>
              <Input type="date" value={editing.paid_date || ""} onChange={(e) => setEditing({ ...editing, paid_date: e.target.value })} className="rounded-sm mt-1" data-testid="fee-edit-paid-date" />
            </div>
          )}

          <div className="pt-2 border-t border-zinc-100 space-y-3">
            <FeeDetailFields value={editing} onChange={setEditing} project={project} />
            <FeeAttachments
              attachments={editing.attachments || []}
              onChange={(fn) => setEditing((prev) => ({ ...prev, attachments: fn(prev.attachments || []) }))}
              projectId={editing.project_id}
              onPreview={onPreview}
            />
          </div>

          <Input value={editing.note} onChange={(e) => setEditing({ ...editing, note: e.target.value })} placeholder="Note" className="rounded-sm" />
        </div>
      )}
      <DialogFooter>
        <Button variant="outline" className="rounded-sm" onClick={() => setEditing(null)}>Cancel</Button>
        <Button className="bg-zinc-900 hover:bg-zinc-800 rounded-sm" onClick={onSave} disabled={saving} data-testid="fee-edit-save">Save</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
